var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vn-bar',{attrs:{"model":_vm.barChart.data,"textField":"label","valueField":"value","staggerLabels":_vm.barChart.staggerLabels,"x-format":",.1f","y-format":",.2f"}})
}
var staticRenderFns = []

export { render, staticRenderFns }